module.exports = __webpack_public_path__ + "img/moldova.32899cea.svg";